import { render, staticRenderFns } from "./clientdashboard-my-schools.vue?vue&type=template&id=06efa9fa&"
import script from "./clientdashboard-my-schools.vue?vue&type=script&lang=js&"
export * from "./clientdashboard-my-schools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports